import { FormValues, useDebounce } from '../../duck';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useGetPublicDistrictsLazyQuery } from '@lon/mathnation-suit/requests';
import { AsyncSelect } from '@lon/shared/components';

const SelectDistrict: React.FC<{
  option?: { label: string; value: string };
}> = ({ option }) => {
  const lengthToFetch = 3;

  const [fetch, { loading }] = useGetPublicDistrictsLazyQuery();
  const { getValues, setValue } = useFormContext<FormValues>();
  const [search, setSearch] = React.useState('');
  const [districtValue, setDistrictValue] = React.useState<{
    label: string;
    value: string;
  } | null>(option || null);

  const loadOptions = useDebounce(
    (value, callback) => {
      fetch({
        variables: {
          name: value.trim(),
          state: getValues('state'),
          page: 1,
          itemsPerPage: 999,
        },
        fetchPolicy: 'cache-first',
      }).then((res) => {
        callback(
          res.data?.newDistricts?.collection?.filter(Boolean).map((item) => ({
            value: item.id,
            label: item.globalName,
          })) || []
        );
      });
    },
    { timeoutMs: 300 }
  );

  React.useEffect(() => {
    if (option) {
      setDistrictValue(option);
      setValue('district', option.value);
    }
  }, [option, setValue]);

  const handleInputChange = (value: string) => {
    setSearch(value);
  };

  const handleChange = (selected: any) => {
    if (selected) {
      setValue('district', selected.value);
      setDistrictValue(selected);
    } else {
      setValue('district', '');
      setDistrictValue(null);
    }
  };

  return (
    <AsyncSelect
      name="districts"
      isRequired
      label="District"
      placeholder="Select your district"
      returnObject
      menuIsOpen={search.trim().length >= lengthToFetch}
      formLabelProps={{
        requiredIndicator: undefined,
      }}
      loadOptions={(value: any, callback: any) => {
        if (value.trim().length < lengthToFetch) {
          return callback([]);
        }
        loadOptions(value, callback);
      }}
      isDisabled={!getValues('state')}
      inputValue={search}
      value={districtValue}
      showClearIndicator
      withoutDropdownIndicator
      defaultOptions
      onInputChange={handleInputChange}
      onChange={handleChange}
      isLoading={loading}
    />
  );
};

export default SelectDistrict;
